






























































































import {Component, Prop, Vue} from 'vue-property-decorator'
import Avatar from "@/components/lfs/NewStatistics/GeneralDashboard/common/Avatar.vue";
import BtnDefault from "@/components/UI/BtnDefault.vue";
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";
import {maxBy} from "lodash";

@Component({
  name: 'StandmansRatingListPdf',
  components: {ErrorFetchingData, Avatar, BtnDefault}
})

export default class StandmansRatingList extends Vue {
  @Prop({ type: Boolean, default: false }) protected loading!: boolean
  @Prop({ type: Boolean, default: false }) protected error!: boolean
  @Prop({ type: Boolean, default: false }) protected isPdf!: boolean
  @Prop({ type: Array, default: () => [] }) protected byCount!: any
  @Prop({ type: Array, default: () => [] }) protected byFilling!: any
  @Prop({ type: Number, default: 0 }) protected activeStandmans!: any
  @Prop({ type: Number, default: 0 }) protected totalStandmans!: any

  tab: string | null = null

  pickFirstName(fullName: string) {
    const arrayNames = fullName.split(' ')
    return arrayNames[0] ? arrayNames[0] : ''
  }
  pickLastName(fullName: string) {
    const arrayNames = fullName.split(' ')
    return arrayNames[1] ? arrayNames[1] : ''
  }

  get filledStandmansCount() {
    let byCount = 0
    let byFilling = 0
    this.byCount.forEach((el: any) => {
      if (!el.scansCount) return
      byCount += 1
    })
    this.byFilling.forEach((el: any) => {
      if (!el.notesCount) return
      byFilling += 1
    })
    return byCount >= byFilling ? byCount  : byFilling
  }

  get hasByCountFilled() {
    return this.byCount.some((standman: any) => standman.scansCount)
  }
  get hasByFillingFilled() {
    return this.byFilling.some((standman: any) => standman.notesCount)
  }
  get percentContacts() {
    const maxValue: any = maxBy(this.byCount, 'scansCount')
    return maxValue.scansCount / 100
  }
  get percentContent() {
    const maxValue: any = maxBy(this.byFilling, 'notesCount')
    return maxValue.notesCount / 100
  }

  calculateContactsWidth(width: number) {
    return Math.round(width / this.percentContacts) + '%'
  }
  calculateContentWidth(width: number) {
    return Math.round(width / this.percentContent) + '%'
  }
}
